import { render, staticRenderFns } from "./ElraReport8FullPicture.vue?vue&type=template&id=63ddcedd&scoped=true"
import script from "./ElraReport8FullPicture.vue?vue&type=script&lang=ts"
export * from "./ElraReport8FullPicture.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8FullPicture.vue?vue&type=style&index=0&id=63ddcedd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddcedd",
  null
  
)

export default component.exports